import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: 'admin' | 'provider' | 'staff' | 'patient' | 'external';
  isGuest?: boolean; // True if user is a B2B guest user
}

interface AuthState {
  user: AuthUser | null;
  lastActivity: number;

  // Actions
  setUser: (user: AuthUser | null) => void;
  updateLastActivity: () => void;
  clearUser: () => void;
  isSessionExpired: () => boolean;
}

const SESSION_TIMEOUT_MS = (parseInt(import.meta.env.VITE_SESSION_TIMEOUT_MINUTES || '15', 10)) * 60 * 1000;

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      lastActivity: Date.now(),

      setUser: (user) => set({ user, lastActivity: Date.now() }),

      updateLastActivity: () => set({ lastActivity: Date.now() }),

      clearUser: () => set({ user: null }),

      isSessionExpired: () => {
        const { lastActivity, user } = get();
        if (!user) return false;
        return Date.now() - lastActivity > SESSION_TIMEOUT_MS;
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ user: state.user, lastActivity: state.lastActivity }),
    }
  )
);
